import React from "react";

/**
 * Money — the hero of every Zalso view. Renders a EUR amount in JetBrains Mono
 * with tabular figures, right-aligned by convention. German formatting
 * (1.234,50 €). Negative amounts (Storno/Retoure) render in danger color.
 */
export function Money({
  value = 0,
  size = "l",
  align = "right",
  showSign = false,
  currency = "€",
  color,
  style = {},
  ...rest
}) {
  const sizes = {
    xl: { font: "var(--type-amount-xl-size)", weight: 700, ls: "-0.01em" },
    l:  { font: "var(--type-amount-l-size)",  weight: 600, ls: 0 },
    m:  { font: "16px", weight: 600, ls: 0 },
    s:  { font: "13px", weight: 600, ls: 0 },
  };
  const s = sizes[size] || sizes.l;

  const neg = value < 0;
  const abs = Math.abs(value);
  const formatted = abs.toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const sign = neg ? "−" : showSign ? "+" : "";

  return (
    <span
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: s.font,
        fontWeight: s.weight,
        letterSpacing: s.ls,
        fontFeatureSettings: "'tnum' 1, 'lnum' 1",
        fontVariantNumeric: "tabular-nums lining-nums",
        color: color || (neg ? "var(--danger)" : "inherit"),
        textAlign: align,
        whiteSpace: "nowrap",
        display: "inline-block",
        ...style,
      }}
      {...rest}
    >
      {sign}{formatted}{"\u00A0"}{currency}
    </span>
  );
}
